import DOM from 'quickdom'

export popup = DOM.template(
	['div'
		ref: 'popup'
		style:
			boxSizing: 'border-box'
			width: '100%'
			backgroundColor: 'white'
			borderRadius: 5
			padding: '70px 20px'
	]
)

export qrcode = popup.extend(
	['div'
		ref: 'qrcode'
		style:
			padding: '70px 20px'

		['img'
			ref: 'code-img'
			computers: qrcode: (src)-> @attr {src}
			style:
				margin: '0 auto'
				width: 230
		]
	]
)

export zellepopup = popup.extend(
	['div'
		ref: 'zellepopup'
		style:
			padding: '40px 30px'
			width: 300
			fontSize: 22
			fontWeight: 500
			textAlign: 'center'

		['i'
			ref: 'icon'
			style:
				display: 'block'
				fontSize: 42
				marginBottom: 30
		,'k']

		"Use my "
		['span'
			ref: 'label'
			computers: zelle: (value)->
				@text = if value.includes('@') then 'email address' else 'phone number'
		]
		" to make/request payments:"

		['div'
			ref: 'value'
			style:
				marginTop: 20
				fontSize: 24
				color: '#2f84ff'
				overflowWrap: 'break-word'
			computers:
				zelle: (value)-> @text = value
		]
	]
)

export paypalpopup = zellepopup.extend(
	ref: 'paypalpopup'
	options: ref: 'paypalpopup'
	children:
		value: options: computers:
			paypal: (value)-> @text = value
		label: options: computers:
			paypal: (value)->
				@text = if value.includes('@') then 'email address' else 'phone number'
		icon:
			options: style:
				fontSize: 62
			children: ['K']
)


export addToHome = popup.extend(
	['div'
		ref: 'addToHome'
		style:
			padding: '40px 30px'
			width: 300
			fontSize: 22
			fontWeight: 500
			textAlign: 'center'

		"Step 1:"
		['div'
			style:
				fontSize: 15
				margin: '8px 0 13px'
		, "Tap on your browser's share button"]
		['img'
			attrs: src: '/files/img/share-tutorial/share-step-1.png'
			style:
				width: '100%'
				boxShadow: '0px 1px 5px rgba(0,0,0,0.19)'
				marginBottom: 20
		]

		['div'
			ref: 'divider'
			style:
				width: '100%'
				height: 1
				margin: '8px 0'
				backgroundColor: '#ddd'
		]
		
		"Step 2:"
		['div'
			style:
				fontSize: 15
				margin: '8px 0 13px'
		, "Tap on \"Add to Home Screen\""]
		['img'
			attrs: src: '/files/img/share-tutorial/share-step-2.png'
			style:
				width: '100%'
				boxShadow: '0px 1px 5px rgba(0,0,0,0.19)'
		]
	]
)

